// 前台主畫面 component

<template>
<div>
  <!-- <transition name="slide-fade" mode="out-in"> -->
    <div class="row main-layout" v-if="mountedFinished" key="main">
      <!-- 
        follow line puts the medAppPrivilege variable in template to 
        make Vue can trace it's status, wait for it to finish the layout.
      -->
      <!-- <p style="display: none">{{ medAppPrivilege }}</p>  -->
      <div :class="{ 'col-8': subfun.title === '藥物管理', 'col-4': subfun.title === '藥櫃設定' }"
        v-for="subfun in all_functions"
        >
        <div class="main-sublayout">
          <p class="main-sublayout--title ">{{ subfun.title }}</p>
          <!-- <hr/> -->
          <div 
            :class="{
              'function-button': true, 
              'd-inline-block': true,
              'm-1': true, 
              'danger-button': fun.url_name === 'disabledDevices',
              'not-ready': fun.ready === false,
              }" 
            :id="fun.url_name"
            v-for="fun in subfun.functions" 
            v-if="fun.privilege">
            <router-link :to="{ name: fun.url_name}" >
              <div class="icon-wrap">
                <img :src="`/static/svg/${fun.icon_name}`" alt="">
              </div>
              <div class="text-center">
                {{ fun.name }}
              </div>

              <!-- alert icon -->
              <div class="badge-alert" 
                v-if="fun.url_name === 'removeOutdatedDrug' && outdateCount !== 0">
                <span>{{ outdateCount }}</span>
              </div>
              <div class="badge-alert" 
                v-if="fun.url_name === 'refillDrug' && lowCount !== 0">
                <span>{{ lowCount }}</span>
              </div>
              <div class="badge-alert" 
                v-if="fun.url_name === 'storageError' && storageErrorCount !== 0">
                <span>{{ storageErrorCount }}</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="bottom-layout">
          <div class="clock">
            <Clock/>
            <span class="clock-text">
              <p>現在時間</p>
              {{ time }}
            </span>
          </div>
          <div class="system-env-wrap">
            <div class="system-env">
              <span>藥櫃溫度</span>
              <p>{{$store.state.temperature}} <span>℃</span></p>
            </div>
            <div class="system-env">
              <span>藥櫃濕度</span>
              <p>{{$store.state.humidity}} <span>%</span></p>
            </div>
          </div>
          <span>
            <p style="margin: 0">版本: {{ version }}</p>
            <p v-if="$store.state.device.systemArea !== null" style="margin: 0">藥櫃位置：{{ $store.state.device.systemArea | areaFormat }}</p>
          </span>
        </div>
      </div>
    </div>
    <div class="row main-layout" v-else key="loading">
      <div class="main-layout--center">
        <ClipLoader/>
        <p>更新系統資訊中</p>
      </div>
    </div>
  <!-- </transition> -->
</div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import ClipLoader from 'vue-spinner/src/ClipLoader';
import { version } from '@/config';
import Clock from './common/Clock';

Vue.component('action-button', {
  props: {
    title: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  template: `
    <button class="btn control-button control-button-red" :disabled="clickable === false">
      <div class="button-inside-wrap">
        <span>{{ title }}</span>
      </div>
    </button>
  `,
});


function humanlized(context) {
  let errorMsg = '<h5>偵測到藥盒或藥櫃未關閉</h5><hr/>';
  const drawer = [];
  const box = [];
  let drawerMsg = ' ';
  let boxMsg = '';
  context.forEach((element) => {
    if (element.type === 'drawer') drawer.push(element);
    if (element.type === 'box') box.push(element);
  });

  if (drawer.length !== 0) {
    drawer.forEach((d) => {
      drawerMsg = drawerMsg.concat(`<p>第 ${d.system + 1} 藥櫃 - 第 ${d.drawerId} 層抽屜 </p>`);
    });
    errorMsg = errorMsg.concat(drawerMsg);
  }

  if (box.length !== 0) {
    box.forEach((b) => {
      boxMsg = boxMsg.concat(`<p>第 ${b.system + 1} 藥櫃 - 第 ${b.drawerId} 層抽屜 - <span class="device-warning-msg">${b.row} 列 - ${b.col} 行</span> 藥盒</p>`);
    });
    // boxMsg = boxMsg.concat('抽屜未關</h6>');
    errorMsg = errorMsg.concat(boxMsg);
  }
  errorMsg = errorMsg.concat('<hr/><p>請關閉所有抽屜及藥盒</p>');

  return errorMsg;
}

export default {
  name: 'Main',
  data() {
    return {
      hour: '',
      min: '',
      sec: '',
      month: '',
      day: '',
      version: '',
      timeoutFun: null,
      intervalFun: null,
      timeRemain: 1000 * 10,
      mountedFinished: true,
      errorDevicesPrevious: [],
      errorDevicesPreviousBySys: {},
      confirmTimes: 0,
    };
  },
  components: {
    Clock,
    ClipLoader,
  },
  async created() {
    this.$store.commit('CLOSE_MESSAGE');
    this.$store.commit('SET_APP', '功能選擇');
    this.$store.dispatch('resetAll');
    this.version = version;
    // indicate the loading progress on main panel
    this.$store.state.apps.management.functions.removeOutdatedDrug.ready = false;
    this.$store.state.apps.management.functions.refillDrug.ready = false;
    this.$store.state.apps.setting.functions.drugStorageSummary.ready = false;
    this.$store.state.apps.management.functions.schedule.ready = false;
    //20190411 add by aaron
    this.$store.state.apps.management.functions.fetchDrugSchedule.ready = false;
    // this.$store.dispatch('webSocketConnect');
    await this.$store.dispatch('initSystemInfo');
    // this.mountedFinished = true;
    // update the loading progress.
    this.$store.state.apps.management.functions.removeOutdatedDrug.ready = true;
    this.$store.state.apps.management.functions.refillDrug.ready = true;
    this.$store.state.apps.setting.functions.drugStorageSummary.ready = true;
    this.$store.state.apps.management.functions.schedule.ready = true;
    //20190411 add by aaron
    this.$store.state.apps.management.functions.fetchDrugSchedule.ready = true;
  },
  mounted() {
    this.startTime();
    this.$store.commit('SHOW_LOGOUT', true);
  },
  destroyed() {
    this.$store.commit('SHOW_LOGOUT', false);
  },
  methods: {
    startTime() {
      const today = new Date();
      this.hour = today.getHours();
      this.min = today.getMinutes();
      this.sec = today.getSeconds();
      this.min = this.checkTime(this.min);
      this.sec = this.checkTime(this.sec);
      this.month = today.getMonth() + 1;
      this.day = today.getDate();
      setTimeout(this.startTime, 500);
    },
    checkTime(i) {
      if (i < 10) {
        return '0'.concat(i);
      }
      return i;
    },
    debouncedDetectErrorDevice: _.debounce((vm) => {
      if (vm.errorDevices.length !== 0) {
        if (vm.$store.state.currentApp.name === '功能選擇' && vm.$store.state.message.keepOnTop === false) {
          vm.$store.commit('SET_MESSAGE', {
            type: 'error',
            // context: this.errorDevices,
            context: humanlized(vm.errorDevices),
            showUnlock: true,
            confirm: true,
          });
        }
      } else {
        if (vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
          vm.$store.commit('CLOSE_MESSAGE');
        }
      }
    }, 100),
    hasAtLeastTwoErrorDrawers(errorDevices) {
      const drawerids = [];
      errorDevices.forEach((item) => {
        if (item.type === 'drawer') {
          drawerids.push(item.drawerId);
        }
      });

      if (drawerids.length >= 2) return true;
      return false;
    },
    checkArraySame(a, b) {
      // console.log(a, b);
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length !== b.length) return false;

      // If you don't care about the order of the elements inside
      // the array, you should sort both arrays here.

      for (let i = 0; i < a.length; i += 1) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    },
    errorDevicesAndPreviousErrorDevicesAreSame() {
      const nowDeviceId = [];
      const preDeviceId = [];
      this.errorDevices.forEach((item) => {
        nowDeviceId.push(`${item.system}-${item.drawerId}`);
      });
      this.errorDevicesPrevious.forEach((item) => {
        preDeviceId.push(`${item.system}-${item.drawerId}`);
      });
      return this.checkArraySame(nowDeviceId, preDeviceId);
    },
    forceShutDown(systemId) {
      this.$store.getters.instance.patch(`/api/system/${systemId}/`, {
        force_shutdown: true,
      });
    },
    separateDeviceBySys(errorDevices) {
      this.errorDevicesPreviousBySys = {};
      errorDevices.forEach((item) => {
        if (!(item.system in this.errorDevicesPreviousBySys)) {
          this.errorDevicesPreviousBySys[item.system] = [];
        } else {
          this.errorDevicesPreviousBySys[item.system].push(item);
        }
      });
    },
  },
  computed: {
    messageStatus() {
      return this.$store.getters.messageStatus;
    },
    time() {
      return `${this.month}/${this.day} ${this.hour}:${this.min}:${this.sec}`;
    },
    lowCount() {
      return this.$store.state.drugInDevice.drugInDeviceLowStockList.length;
    },
    outdateCount() {
      return this.$store.state.drugInDevice.expiredDrugInDevice.length;
    },
    storageErrorCount() {
      return this.$store.state.drugInDevice.storageErrorCount;
    },
    medAppPrivilege() {
      return this.$store.state.user.user.med_app_privilege;
    },
    errorDevices() {
      return this.$store.state.device.errorDevices;
    },
    all_functions() {
      return this.$store.state.apps;
    },
  },
  filters: {
    areaFormat(obj) {
      return obj.department.name + obj.name;
    },
  },
  watch: {
    errorDevices() {
      this.debouncedDetectErrorDevice(this);
    },
    messageStatus(val) {
      if (val === false) {
        if (this.errorDevicesAndPreviousErrorDevicesAreSame()) {
          console.log('same error devices');
          Object.values(this.errorDevicesPreviousBySys).forEach((errorDevicesInSys) => {
            if (this.hasAtLeastTwoErrorDrawers(errorDevicesInSys)) {
              const systemId = Object.keys(this.$store.getters.systems)[errorDevicesInSys[0].system];
              this.forceShutDown(systemId);
            }
          });
          if (this.hasAtLeastTwoErrorDrawers(this.errorDevicesPrevious)) {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '因硬體問題，已限制藥櫃取用。請與工程人員聯絡或重新登入。',
              keepOnTop: true,
            });
            this.$router.push({ name: 'Login' });
          }
        } else {
          console.log('not same error devices');
        }
        this.errorDevicesPrevious = this.errorDevices.slice();
        this.separateDeviceBySys(this.errorDevicesPrevious);
        console.log(val);
      }
    },
  },
};
</script>

<style lang="sass">
$bottom-height: 120px;

.main-layout
  display: flex
  height: calc(738px - 70px);
  .col-8, .col-4
    padding: 0 0 0 0px
  .col-4
    height: calc(100% - #{$bottom-height});
  .col-12
    // height: $bottom-height;
    background: #f4f4f4;
    // border-radius: 0px 0px 10px 10px;
    border-top: 1px solid rgba(0,0,0,0.05);
    color: rgba(0,0,0,0.5)
    p
      font-size: 12px

.bottom-layout
  display: flex
  align-items: center
  span
    margin-left: auto

.main-sublayout
  padding: 0px 10px;
  height: 560px;
  overflow-y: auto;
  &::-webkit-scrollbar
    display: none
  .main-sublayout--title
    font-size: 20px
    font-weight: 500
    text-align: left
    padding: 12px 0
    margin: 0.5rem;
    border-bottom: 1px solid gainsboro;
  a
    color: white
    text-decoration: none
  
.main-layout--center
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  width: 100%
  p
    margin-top: 1rem

.function-button
  position: relative
  width: 147px;
  height: 147px;
  background-color: steelblue;
  box-shadow: 0 1px 5px rgba(0,0,0,.2), 0 2px 2px rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12)
  border-radius: 5px
  &:active
    -moz-box-shadow:    inset 0 0 10px #000000;
    -webkit-box-shadow: inset 0 0 10px #000000;
    box-shadow:         inset 0 0 10px #000000;
  .text-center
    color: white
  transition-duration: 1s

.not-ready
  background: #ff960c
  pointer-events: none;

.icon-wrap 
  height: 110px;
  flex-direction: column;
  display: flex;
  img
    width: 70px;
    margin: auto;
    -webkit-user-drag: none;

.badge-alert
  position: absolute;
  top: -8px;
  right: -8px;
  width: 30px;
  height: 30px;
  background: red;
  border-radius: 50%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);

.clock
  display: inline-flex;
  align-items: center;
  .clock-text
    font-size: 16px
    p
      font-size: 14px
      margin-bottom: 2px

.device-warning-msg
  color: #fff25b

.system-env-wrap
  margin-left: auto
  display: flex

.system-env
  min-width: 230px 
  p
    font-size: 30px !important
    margin-left: 40px
    margin-bottom: 0px
    span
      font-size: 12px

.danger-button
  background: red
</style>



// WEBPACK FOOTER //
// Main.vue?50ffc6bc